import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function NotesSwiperSection({
  variant = "women", // "women" | "men"
  Artboard1,
  Artboard2,
  Artboard3,
  NoteBlock,
}) {
  const { t } = useTranslation();

  const noteBlocks = useMemo(() => {
    const prefix = variant === "men" ? "Men" : "Women";

    return [
      { image: Artboard1, title: t("Top"), notes: t(`${prefix}Top`) },
      { image: Artboard2, title: t("Middle"), notes: t(`${prefix}Middle`) },
      { image: Artboard3, title: t("Base"), notes: t(`${prefix}Base`) },
    ];
  }, [variant, Artboard1, Artboard2, Artboard3, t]);

  return (
    <>
      {/* ✅ Mobil: Swiper */}
      <div className="d-lg-none">
        <Swiper
          slidesPerView={1}
          spaceBetween={16}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="mySwiper pb-5"
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 12 },
            480: { slidesPerView: 1.1, spaceBetween: 12 },
            640: { slidesPerView: 1.3, spaceBetween: 16 },
          }}
        >
          {noteBlocks.map((item, idx) => (
            <SwiperSlide key={idx}>
              <NoteBlock
                image={item.image}
                title={item.title}
                notes={item.notes}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* ✅ Desktop: Aynı kalsın */}
      <div className="d-none d-lg-block">
        {noteBlocks.map((item, idx) => (
          <NoteBlock
            key={idx}
            image={item.image}
            title={item.title}
            notes={item.notes}
          />
        ))}
      </div>
    </>
  );
}
